import {eatalianoAxios} from "@/data/api/http/axios";
import {LoyaltyRewardDetails, LoyaltyRewardFormValues} from "@/data/entities/loyaltyReward";
import {UpdatedOrdering} from "@/utils/Ordering";

export const listLoyaltyRewards = (restaurantId: number): Promise<LoyaltyRewardDetails[]> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/rewards`)
        .then(response => response.data)
);

export const deleteLoyaltyReward = (
    restaurantId: number,
    loyaltyRewardId: number,
): Promise<LoyaltyRewardDetails[]> => (
    eatalianoAxios
        .delete(`/restaurant/${restaurantId}/rewards/${loyaltyRewardId}`)
        .then(response => response.data)
);

export const updateLoyaltyRewardsOrdering = (
    restaurantId: number,
    updatedOrdering: UpdatedOrdering[],
): Promise<LoyaltyRewardDetails[]> => (
    eatalianoAxios
        .put(`/restaurant/${restaurantId}/rewards/ordering`, updatedOrdering)
        .then(response => response.data)
);

export const getLoyaltyRewardDetails = (
    restaurantId: number,
    loyaltyRewardId: number,
): Promise<LoyaltyRewardDetails> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/rewards/${loyaltyRewardId}`)
        .then(response => response.data)
);

export const createLoyaltyReward = (
    restaurantId: number,
    fields: LoyaltyRewardFormValues,
): Promise<LoyaltyRewardDetails> => (
    eatalianoAxios
        .post(`/restaurant/${restaurantId}/rewards`, fields)
        .then(response => response.data)
);

export const updateLoyaltyReward = (
    restaurantId: number,
    loyaltyRewardId: number,
    fields: LoyaltyRewardFormValues,
): Promise<LoyaltyRewardDetails> => (
    eatalianoAxios
        .put(`/restaurant/${restaurantId}/rewards/${loyaltyRewardId}`, fields)
        .then(response => response.data)
);